// interceptors/function-key.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'environments/environment';

export const functionKeyInterceptor: HttpInterceptorFn = (req, next) => {
  // Only add key for your API calls and if key exists
  if (req.url.startsWith(environment.apiUrl) && environment.functionKey) {
    req = req.clone({
      setHeaders: {
        'x-functions-key': environment.functionKey
      }
    });
  }
  
  return next(req);
};